import type { AppRedirect } from 'src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	// TODO move redirect to nginx
	{
		path: '/browse',
		buildUrl: () => '/search',
		reason: 'deprecated-page',
	},
	{
		path: '/browse/:type',
		buildUrl: () => '/search',
		reason: 'deprecated-page',
	},
];
